import { useState, type ReactNode } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CredentialVaultTab } from "./credential-vault-view";

/** Keep both views mounted so switching tabs preserves uploads and selection.
 * With `view` the caller switches views (the provider page's own tabs) and
 * this tab list is hidden. */
export function CredentialVaultTabs({
  credentials,
  files,
  view,
}: {
  credentials: ReactNode;
  files: ReactNode;
  view?: CredentialVaultTab;
}) {
  const [selectedTab, setActiveTab] = useState(CredentialVaultTab.Credentials);
  const activeTab = view ?? selectedTab;
  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => setActiveTab(value as CredentialVaultTab)}
      className="flex min-h-0 flex-1 flex-col"
    >
      <div
        hidden={view !== undefined}
        className="shrink-0 border-b border-slate-200 px-4 py-3 sm:px-6"
      >
        <TabsList
          aria-label="Credential vault views"
          className="grid h-auto w-full grid-cols-2 rounded-xl bg-slate-100 p-1"
        >
          <TabsTrigger value="credentials" className="rounded-lg py-2.5">
            Credentials
          </TabsTrigger>
          <TabsTrigger value="files" className="rounded-lg py-2.5">
            Files
          </TabsTrigger>
        </TabsList>
      </div>
      <TabsContent
        value="credentials"
        forceMount
        hidden={activeTab !== CredentialVaultTab.Credentials}
        className="mt-0 min-h-0 flex-1 overflow-y-auto overscroll-contain bg-slate-50 px-4 py-4 sm:px-6 sm:py-5"
      >
        {credentials}
      </TabsContent>
      <TabsContent
        value="files"
        forceMount
        hidden={activeTab !== CredentialVaultTab.Files}
        className="mt-0 min-h-0 flex-1 overflow-hidden bg-slate-50"
      >
        {files}
      </TabsContent>
    </Tabs>
  );
}
